import { gql, useMutation } from '@apollo/client';

export const UPDATE_SHIPMENT_PRINT_STATUS_MUTATION = gql`
  mutation UpdateShipmentPrintStatus($shipmentIds: [Int!]!, $dain: String!) {
    poSaleOrder {
      updateShipmentPrintStatus(shipmentIds: $shipmentIds, dain: $dain) {
        success
        content
        message {
          code
          message
        }
      }
    }
  }
`;

export interface UpdateShipmentPrintStatusMutationVariables {
  shipmentIds: number[];
  dain: string;
}

export const useUpdateShipmentPrintStatusMutation = (options?: any) =>
  useMutation(UPDATE_SHIPMENT_PRINT_STATUS_MUTATION, options);

